export default __webpack_public_path__ + "static/media/JEEP.d260e805.png";